import { Injectable } from '@angular/core';
import { CookieOptions } from '@core/models/cookie-options.model';
import { CookieService } from '@shared/services/cookie.service';

@Injectable()
export class BrowserCookieService implements CookieService {
  // Use the parent domain to allow sharing cookies between subdomains
  private _domain = this.getParentDomain(window.location.hostname);

  constructor() {
  }

  setCookie(key: string, value: string, options?: CookieOptions): void {
    const timestamp = Date.now();
    const maxAge = options && options.maxAge ? options.maxAge : 3.154e11;
    const expireTimestamp = timestamp + maxAge;
    const dateString = new Date(expireTimestamp).toUTCString();
    const encodedData = encodeURIComponent(value);
    const domain = options && options.domain ? options.domain : this._domain;
    document.cookie = `${key}=${encodedData}; expires=${dateString}; domain=${domain}; path=/`;
  }

  getCookie(key: string): string {

    const cookieReplace = new RegExp(
      `(?:(?:^|.*;\\s*)${key}\\s*\\=\\s*([^;]*).*$)|^.*$`
    );
    const encodedData = document.cookie.replace(cookieReplace, '$1');
    const value = decodeURIComponent(encodedData);

    return value;
  }

  deleteCookie(key: string, options: CookieOptions): void {
    const date = new Date(0);
    const dateString = date.toUTCString();
    const domain = options && options.domain ? options.domain : this._domain;
    document.cookie = `${key}=; expires=${dateString}; domain=${domain}; path=/`;
  }

  /**
   * Gets the parent domain from a hostname
   * For example, from 'estimator.flyevo.localhost' it returns '.flyevo.localhost'
   */
  private getParentDomain(hostname: string): string {
    // Split the hostname by dots
    const parts = hostname.split('.');

    // If we have at least 3 parts (subdomain.domain.tld), return the domain with a leading dot
    if (parts.length >= 3) {
      // Remove the first part (subdomain) and join the rest with dots, adding a leading dot
      return '.' + parts.slice(1).join('.');
    }

    // If we don't have enough parts, just return the original hostname
    return hostname;
  }
}
